/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */

'use client';

import { useState } from 'react';
import Link from 'next/link';
import {
  Container, Row, Col, Form, Input, Label,
} from 'reactstrap';
import Image from 'next/image';

// Import Icons
import FeatherIcon from 'feather-icons-react';

// Import Images
import logolight from '../../../assets/images/logo-light.png';
import logodark from '../../../assets/images/logo-dark.png';

import { addNewsSubscription } from '../../../services/users.service';
import { sendMetrics } from '../../../services/ga.service';

function Footer(props) {
  const [success, setSuccess] = useState(false);

  const state = {
    // Every section of the site, so the footer describes its structure rather
    // than a sample of it. Shop, AI Widgets and FAQs were missing: FAQs in
    // particular had no internal link anywhere once it left the top menu, and a
    // page nothing links to is crawled less and drifts down — it still brings
    // ~18 organic sessions a month, which is not worth losing to a tidier menu.
    grid1: [
      // { title: 'About us', link: '#' },
      { title: 'Coilmind', link: '/coilmind' },
      { title: 'Converter', link: '/converter' },
      { title: 'AI Widgets', link: '/ai-generator' },
      { title: 'Shop', link: '/shop' },
      // { title: 'Team', link: '#' },
      { title: 'Pricing', link: '/pricing' },
      { title: 'Blog', link: '/blog' },
      { title: 'FAQs', link: '/faq' },
      { title: 'Login', link: '/auth-login' },
    ],
    grid2: [
      { title: 'Terms of Services', link: '/terms' },
      { title: 'Privacy Policy', link: '/page-privacy' },
      // A buyer's IT department looks for this before procurement, not after.
      { title: 'Data Processing Agreement', link: '/dpa' },
      { title: 'Converter License', link: '/converter-license' },
      { title: 'MCP Server for AI Agents', link: '/mcp' },
      { title: 'Contact Us', link: '/contact' },
      // { title: 'Changelog', link: '#' },
    ],
  };

  const onSubscribe = (e) => {
    e.preventDefault();
    sendMetrics('new_subscription_footer');
    addNewsSubscription(e.target.emailsubscribe.value);
    setSuccess(true);
    setTimeout(() => (setSuccess(false)), 5000);
  };

  // Success message
  const successMsg = success ? (
    <div role="alert" className="alert alert-success mt-2">
      <i className="uil uil-check-circle fs-5 align-middle me-1" />
      You succesfully subscribed for SVGHMI.pro News!
    </div>
  ) : null;

  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col className="col-12">
            <div className={props.isBorderLine ? 'footer-py-60 footer-border' : 'footer-py-60'}>
              <Row>
                <Col lg={4} className="col-12 mb-0 mb-md-4 pb-0 pb-md-2">
                  <Link href="/" className="logo-footer">
                    <Image
                      src={props.isLight ? logodark : logolight}
                      alt="logo"
                      height="27"
                      width="109"
                    />
                    {/* <img
                      src={props.isLight ? logodark.src : logolight.src}
                      height="24"
                      alt="logo"
                    /> */}
                  </Link>
                  {/* <p
                    className={
                      props.isLight ? 'mt-4 text-muted' : 'mt-4'
                    }
                  >
                    Start working with SVGHMI.pro that can provide
                    you with effective tools to create SCADA HMIs and
                    reduce maintenance costs.
                  </p> */}
                  <p className={props.isLight ? 'mt-4 text-muted' : 'mt-4'}>
                    Cirill Sokolov
                  </p>
                  {/* <p className={props.isLight ? 'mt-2 text-muted' : 'mt-2'}>
                    Russian Federation, Rostov-on-Don, Komarova st. 18/3, apt 95
                  </p> */}
                  {/* <p className={props.isLight ? 'mt-2 text-muted' : 'mt-2'}>
                    INN: 616516977763
                  </p>
                  <p className={props.isLight ? 'mt-2 text-muted' : 'mt-2'}>
                    Contact number: +7-906-416-89-10
                  </p> */}
                  <a href="mailto:support@svghmi.pro?body=Hello, I have a question">support@svghmi.pro</a>
                  <ul
                    className={
                      props.isLight
                        ? 'list-unstyled social-icon social mb-0 m t-4'
                        : 'list-unstyled social-icon foot-social-icon mb-0 mt-4'
                    }
                  >
                    {/* <li className="list-inline-item me-1">
                      <Link href="#" className="rounded">
                        <FeatherIcon
                          icon="facebook"
                          className="fea icon-sm fea-social"
                        />
                      </Link>
                    </li> */}
                    <li className="list-inline-item me-1">
                      <Link
                        href="https://www.youtube.com/@industrial_control"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="rounded"
                      >
                        <FeatherIcon
                          icon="youtube"
                          className="fea icon-sm fea-social"
                        />
                      </Link>
                    </li>
                    <li className="list-inline-item me-1">
                      <Link
                        href="https://www.linkedin.com/in/cirill-sokolov"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="rounded"
                      >
                        <FeatherIcon
                          icon="linkedin"
                          className="fea icon-sm fea-social"
                        />
                      </Link>
                    </li>
                    {/* <li className="list-inline-item me-1">
                      <Link href="#" className="rounded">
                        <FeatherIcon
                          icon="twitter"
                          className="fea icon-sm fea-social"
                        />
                      </Link>
                    </li>
                     */}
                  </ul>
                </Col>

                <Col lg={2} md={4} className="col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <h5
                    className={
                      props.isLight
                        ? 'text-dark footer-head'
                        : 'text-light footer-head'
                    }
                  >
                    Company
                  </h5>
                  <ul className="list-unstyled footer-list mt-4">
                    {state.grid1.map((grid, key) => (
                      <li key={key}>
                        <Link
                          href={grid.link}
                          className={
                            props.isLight ? 'text-muted' : 'text-foot'
                          }
                        >
                          <i className="uil uil-angle-right-b me-1" />
                          {' '}
                          {grid.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Col>

                <Col lg={3} md={4} className="col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <h5
                    className={
                      props.isLight
                        ? 'text-dark footer-head'
                        : 'text-light footer-head'
                    }
                  >
                    Useful Links
                  </h5>
                  <ul className="list-unstyled footer-list mt-4">
                    {state.grid2.map((grid, key) => (
                      <li key={key}>
                        <Link
                          href={grid.link}
                          className={
                            props.isLight ? 'text-muted' : 'text-foot'
                          }
                        >
                          <i className="uil uil-angle-right-b me-1" />
                          {' '}
                          {grid.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Col>

                <Col lg={3} md={4} className="col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <h5
                    className={
                      props.isLight
                        ? 'text-dark footer-head'
                        : 'text-light footer-head'
                    }
                  >
                    Newsletter
                  </h5>
                  <p className="mt-4">Sign up and receive the latest tips via email.</p>
                  <Form onSubmit={onSubscribe}>
                    <Row>
                      <Col lg={12}>
                        <div
                          className={
                            props.isLight
                              ? 'foot-subscribe mb-3 foot-white'
                              : 'foot-subscribe mb-3'
                          }
                        >
                          <Label
                            className={
                              props.isLight
                                ? 'form-label text-muted'
                                : 'form-label'
                            }
                          >
                            Write your email
                            {' '}
                            {' '}
                            <span className="text-danger">*</span>
                          </Label>
                          <div className="form-icon position-relative" suppressHydrationWarning>
                            <FeatherIcon
                              icon="mail"
                              className="fea icon-sm icons"
                            />
                            <Input
                              type="email"
                              name="email"
                              id="emailsubscribe"
                              className={
                                props.isLight
                                  ? 'form-control ps-5 rounded bg-light border'
                                  : 'form-control ps-5 rounded'
                              }
                              placeholder="Your email : "
                              required
                              suppressHydrationWarning
                            />
                          </div>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="d-grid">
                          <input
                            type="submit"
                            id="submitsubscribe"
                            name="send"
                            className={props.isLight ? 'btn btn-primary' : 'btn btn-soft-primary'}
                            value="Subscribe"
                          />
                        </div>
                        {successMsg}
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>

      <div className="footer-py-30 footer-bar">
        <Container className="text-center">
          <Row className="align-items-center">
            <Col sm={6}>
              <div className="text-sm-start">
                <p className="mb-0">
                  ©
                  <span suppressHydrationWarning>
                    {(new Date().getFullYear())}
                  </span>
                  {' '}
                  SVGHMI.pro
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
}

export default Footer;
